import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';

import { Asset as IAsset, AssetType, VehicleVariant } from '@/generated/fleetAggregationServiceTypes';
import { ProductLabel } from './Product';

type AssetProps = {
    asset: Pick<IAsset, 'name' | 'type' | 'product'>;
    showProduct?: boolean;
    className?: string;
};

export const Asset = ({ asset, showProduct = true, className }: AssetProps) => (
    <span className={`${className || ''} display-inline-flex align-items-center`}>
        {asset.type && <span className={`rioglyph rioglyph-${asset.type} margin-right-5`} />}
        <OverlayTrigger placement="top" overlay={<Tooltip width="auto">{asset.name}</Tooltip>}>
            <span className="ellipsis-2 max-width-150 margin-right-5">{asset.name}</span>
        </OverlayTrigger>
        {showProduct && <ProductLabel product={asset.product} />}
    </span>
);

export const SidebarTitleAsset = ({ asset, showProduct }: { asset?: IAsset; showProduct?: boolean }) => {
    // placeholder that size of sidebar header does not change after loading
    if (!asset)
        return (
            <h5 className="invisible">
                <Asset asset={{ type: AssetType.Truck, name: 'Asset' }} showProduct={showProduct} />
            </h5>
        );

    // real rendering of the Asset
    return (
        <h5>
            <Asset asset={asset} showProduct={showProduct} />
        </h5>
    );
};

export const isTG2orTG3 = (asset: IAsset) => asset.vehicleVariant?.toUpperCase() === VehicleVariant.ICAN || asset.vehicleVariant?.toUpperCase() === VehicleVariant.NHMR;

const MODEL_YEAR_2022 = 2022;
export const getModelYear = (asset: IAsset) => Number(asset?.deliveryExWorks?.substring(0, 4));
export const isVehicleModelOlderThan2022 = (asset: IAsset) => getModelYear(asset) < MODEL_YEAR_2022;
